module.exports = __webpack_public_path__ + "img/interview_do.82e1ab0a.jpg";